import { reconciliationMessages } from "@/services/messages";

/**
 * Универсальный label для `Discrepancy.level` — единая семантика с
 * `ResultBanner.tsx:LEVEL_LABEL_KEY`. Используется во всех card-вариантах
 * (фича 024 — Phase 5a refactor).
 *
 * Sprint 3 / A4: legacy `aggregate-by-work-kind` удалён.
 */

const LEVEL_LABEL_KEY: Record<string, keyof typeof reconciliationMessages> = {
	unified: "level_unified",
	position: "level_position",
	"grand-total": "level_grand_total",
};

export function levelLabel(level: "unified" | "position" | "grand-total"): string {
	const key = LEVEL_LABEL_KEY[level];
	if (!key) return level;
	const value = reconciliationMessages[key];
	return typeof value === "string" ? value : level;
}
